import React from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import './NotFound.css';
import backgroundImage from '../assets/basketball-bg.jpg';

const NotFound = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={`not-found-page ${isMobile ? 'mobile' : ''}`}>
      <div 
        className="not-found-hero"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(${backgroundImage})` }}
      >
        <h1 className="not-found-title">404</h1>
        <p className="not-found-subtitle">Page Not Found</p>
        <Link to="/" className="back-home-button">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 